import classNames from "classnames"

import { Title2 } from "@bounce/design-system"
import { useTranslation } from "@bounce/i18n"

import { useSectionViewed } from "../../../../hooks/useSectionViewed"
import SafeLink from "@/components/Generic/SafeLink/SafeLink"
import type { StoreContact as StoreContactType } from "@/hooks/useStoreContact"

export type StoreContactProps = {
  className?: string
  storeContact: StoreContactType
  title: string
}

export const StoreContact = ({
  title,
  storeContact: { name, fullAddress, telephone },
  className,
}: StoreContactProps) => {
  const { t } = useTranslation()
  const { sectionRef } = useSectionViewed({ name: "StoreContact" })

  return (
    <section ref={sectionRef} className={classNames("mx-auto flex w-full max-w-screen-xl flex-col px-6", className)}>
      <Title2 className="mb-6">{title}</Title2>
      <h4 className="text-black">{name}</h4>
      <div className="mt-1">
        <strong className="font-normal text-black">{t("cmp.footer.address", "Address")}:</strong>{" "}
        <h4 className="inline not-italic text-black">{fullAddress}</h4>
      </div>
      <p className="mt-1">
        <strong className="font-normal text-black">{t("cmp.footer.phone", "Phone")}:</strong>{" "}
        <SafeLink href={`tel:${telephone}`} className="text-black">
          {telephone}
        </SafeLink>
      </p>
    </section>
  )
}
